export let newFolderAnnouncementText = "y$R3Od";
export let renameFolderAnnouncementText = "OK2FFb";
export default {newFolderAnnouncementText,renameFolderAnnouncementText};